import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const EventPackagesVenue = loadable(() => import('./EventPackagesVenue'));

EventPackagesVenue.getInitialState = getInitialState;

export default EventPackagesVenue;
